<template>
    <div>
        <a-table
            :columns="columns"
            :rowKey="rowkeyGen"
            :dataSource="files"
            :loading="loading"
            :pagination="false"
            :scroll="{x: 1000}"
            bordered
        >   
            <div
                slot="name-title"
            >
                <span>
                    Név
                </span>
                <a-input-search
                    placeholder="Szűrő"
                    v-on:search="customFilter"
                    v-model="nameFilter"
                >
                    
                </a-input-search>
            </div>
            <span
                slot="tags-col"
                slot-scope="tags"
            >
                <a-tag
                    v-for="tag in tags"
                    color="orange"
                    :key="tag"
                >
                    {{ tag }}
                </a-tag>
            </span>
            <div
                slot="actions-col"
                slot-scope="record"
                :style="{width: '110px'}"
            >
                <a
                    :href="`${record.mediaFile.versions[0].webPath}`"
                    :download="record.niceName"
                    target="_blank"
                >
                <a-button
                    icon="download"
                    type="primary"
                    class="action-button"
                >
                </a-button>
                </a>
                <a-popconfirm 
                    title="Biztos törli?"
                    okText="Igen"
                    cancelText="Nem"
                    v-on:confirm="deleteFile(record)"
                >
                    <a-button 
                        icon="delete"
                        class="action-button"
                    >
                    </a-button>
                </a-popconfirm>
                
            </div>
        </a-table>
    </div>
</template>

<script>

import debounce from 'lodash.debounce'
import { removeFileFromInfo } from '../../../http/api';

export default {
    name: 'FilesListTable',

    // mounted() {
    //     this.fetchList();
    // },

    props: {
        files: {
            type: Array,
            default: () => []
        },
        infoId: {
            type: Number | String,
            default: 0
        }
    },

    data() {
        return {
            data: [],


            loading: false,
            
            nameFilter: '',

            filteredInfo: null,
            sortedInfo: null,
        }
    },
    
    computed: {
        columns() {
            let { sortedInfo, filteredInfo } = this;
            sortedInfo = sortedInfo || {};
            filteredInfo = filteredInfo || {};
            const columns = [
            {
                dataIndex: 'niceName',
                title: 'Fájl Neve',
                key: 'niceName',
                width: '25',
            },
            {
                dataIndex: 'mediaFile.versions[0].mime',
                title: 'Típusa',
                key: 'type',
                width: '25',
            },
            {
                dataIndex: 'createdAt.date',
                title: 'Létrehozva',
                key: 'created',
                width: '25',
            },
            {
                dataIndex: 'mediaFile.versions[0].size',
                title: 'Mérete',
                key: 'size',
                width: '25',
            },
            {
                title: 'Műveletek',
                key: 'operation',
                fixed: 'right',
                width: 100,
                scopedSlots: { customRender: 'actions-col' }
            }
            ];
            return columns;
        },
        tagNamesMap() {
            const map = {};
            this.tagsFilters.forEach(el => {
                map[el.value] = el.text
            })
            return map;
        },
    },

    methods: {

        rowkeyGen(data) {
            return data.id;
        },

        fetchList(params = {}) {
            
            this.data = [
                {
                    filename: 'Video fájl',
                    created: '2019-09-12',
                    modified: '2019-09-13',
                    id: '123',
                    type: 'avi'
                },
                {
                    filename: 'Kép fájl',
                    created: '2019-05-12',
                    modified: '2019-07-13',
                    id: '12345',
                    type: 'jpg'
                },
                {
                    filename: 'Kép fájl',
                    created: '2019-02-12',
                    modified: '2019-03-13',
                    id: '3201',
                    type: 'png'
                },
                {
                    filename: 'Szöveg fájl',
                    created: '2019-12-12',
                    modified: '2019-12-17',
                    id: '121111',
                    type: 'pdf'
                },
                {
                    filename: 'Hang fájl',
                    created: '2019-10-12',
                    modified: '2019-11-13',
                    id: '12342342343',
                    type: 'mp3'
                },
                
            ]
            return;

            console.log('params:', params);
            this.loading = true

            let extraParams = {};
            if (this.nameFilter) {
                extraParams.name = this.nameFilter;
            }

            getAttractionList({
                params: {
                    results: 10, //default
                    ...extraParams,
                    ...params
                }
            })
            .then((res) => {
                const data = res.data;
                const pagination = { ...this.pagination };

                pagination.total = data.info.total;
                pagination.page = data.info.page;

                this.loading = false;
                this.data = data.results;
                this.pagination = pagination;
                
            })
            .catch((err) => {
                console.log(err);
            });
        },
        customFilter(val) {
            console.log(val);

            let options = {
                results: this.pagination.pageSize,
                // page: this.pagination.current,
            }

            if (this.sortedInfo) {
                options.sortField = this.sortedInfo.field;
                options.sortOrder = this.sortedInfo.order;
            }
            if (this.filteredInfo) {
                options = {
                    ...options,
                    ...this.filteredInfo
                }
            }

            this.fetchList(options)
        },

        clearFilters() {
            this.nameFilter = '';
            this.cityFilters = [];

            this.filteredInfo = null;
            this.sortedInfo =  null;

            this.pagination.current = 1;
            this.pagination.pageSize = 10;
            

            this.fetchList();
        },

        downloadFile(record) {
            console.log(record);

        },
        deleteFile(record) {
            console.log(record);
            const options = {
                file_id: record.id,
                info_id: this.infoId
            }
            removeFileFromInfo(options).then(res => {
                console.log('FILE_REMOVED', res);
                this.$emit('fileTableChanged');
            })
        }
    },

    activated() {
        this.fetchList();
    }
}
</script>

<style lang="scss" scoped>
    .action-button {
        margin-left: 8px;
    }
</style>